<template>
  <o-tooltip v-if="allow" :text="displayLabel">
    <o-panel-link
      v-if="slim"
      :tag="component"
      :path="path"
      v-bind="$attrs"
    />
    <o-panel-link
      v-else
      :tag="component"
      :path="path"
      v-bind="$attrs"
    >
      {{ displayLabel }}
    </o-panel-link>
  </o-tooltip>
</template>

<script lang="ts">
export default { name: 'OHistoryLink' }
</script>

<script setup lang="ts">
const { $i18n } = useNuxtApp()
const instance = getCurrentInstance()

interface Props {
  item: Record<string, any>
  model: string
  component?: string
  slim?: boolean
  label?: string
}

const props = withDefaults(defineProps<Props>(), {
  component: 'OButton',
  slim: false,
  label: undefined,
})

const displayLabel = computed(() => props.label ?? $i18n.t('general.history') as string)

const id = computed(() => {
  if (typeof props.item?.objectID === 'function') {
    return props.item.objectID()
  }
  return props.item?.id ?? null
})

const allow = computed(() => {
  const hasPersistedId = id.value !== null && id.value !== undefined && id.value !== ''
  return hasPersistedId && instance?.proxy?.$grants.all({ history: ['view'] })
})

const path = computed(() => {
  const { model } = props
  return `/history?modelType=${model}&primaryKey=${id.value}`
})
</script>
